/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core';
import styles from './styles';

class AudioButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalDuration: 0,
      audioProgress: 0,
    };
  }

  componentDidMount = () => {
    const { audio } = this.props;
    audio.addEventListener('timeupdate', () => {
      const { duration, currentTime } = audio;
      this.setState({
        totalDuration: this.calculateMinutes(duration),
        audioProgress: this.calculateMinutes(currentTime),
      });
    });
  };

  calculateMinutes = time => {
    const minutes = ((time.toFixed(2) / 60) * 100) / 100;
    return minutes;
  };

  toMinutes = time => {
    const format =
      time
        .toFixed(2)
        .toString()
        .replace('.', ':');
    return format;
  };

  render() {
    const { totalDuration, audioProgress } = this.state;

    const {
      t,
      classes: {
        container,
        title,
        description,
        buttonPlay,
        progress,
        progressTime,
        progressEnd,
        divider,
      },
      type,
      audio,
    } = this.props;

    return (
      <React.Fragment>
        <div className={container}>
          <h3 className={title}>{`${type} ${t('components.AudioButtons.title')}:`}</h3>
          <p className={description}>{t('components.AudioButtons.description')}</p>
          <Button
            className={buttonPlay}
            variant="contained"
            color="primary"
            onClick={() => audio.play()}
          >
            {`${t('components.AudioButtons.button1')} ${type}`}
          </Button>
          <Button variant="contained" onClick={() => audio.pause()}>
            {`${t('components.AudioButtons.button2')} ${type}`}
          </Button>
        </div>
        <LinearProgress
          color="secondary"
          variant="determinate"
          value={(100 * audioProgress) / totalDuration}
        />
        <div className={progress}>
          <span className={progressTime}>{this.toMinutes(audioProgress)}</span>
          <span className={[progressTime, progressEnd].join(' ')}>
            {this.toMinutes(totalDuration)}
          </span>
        </div>
        <Divider className={divider} />
      </React.Fragment>
    );
  }
}

AudioButtons.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  audio: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(AudioButtons));
